export default "/images/logo-light-icon.png?e00d058f61e8e8364a087808c064182c";